module.exports = "<p>\n\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/apps/asna/front-end/public_html/src/app/components/login-signup/account-activation/account-activation.component.html
// module id = ../../../../../src/app/components/login-signup/account-activation/account-activation.component.html
// module chunks = main